import Title from '@cohort/components-xps/components/Title';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import CenteredContent from '@cohort/wallet/components/layout/CenteredContent';
import {LogIn} from '@cohort/wallet/components/modals/auth/LogIn';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import MerchantInfos from '@cohort/wallet/pages/space/MerchantInfos';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

const MerchantSpaceLoginPage: React.FC = () => {
  const merchant = useMerchantContext();
  const {hasDarkBg, accentColor} = useThemeContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.merchantSpaceLoginPage'});

  return (
    <SpacePage
      title="Login"
      tracking={{
        namespace: 'login',
      }}
      leftPanel={<MerchantInfos />}
    >
      <CenteredContent className="max-w-xl px-4 md:px-0">
        {merchant.emailSigninEnabled ? (
          <LogIn isForBuying={false} />
        ) : (
          <div className="space-y-4">
            <Title content={t('accessRestrictedTitle')} />
            {merchant.embedUrl && (
              <p className={cn('text-lg', hasDarkBg ? 'text-white/50' : 'text-black/50')}>
                <Trans
                  i18nKey="space.merchantSpaceLoginPage.embedUrlDescription"
                  ns="pages"
                  components={{
                    externalLink: <a style={{color: accentColor}} href={merchant.embedUrl} />,
                  }}
                  values={{url: merchant.embedUrl}}
                />
              </p>
            )}
            {merchant.supportEmail && (
              <p className={cn('text-lg', hasDarkBg ? 'text-white/50' : 'text-black/50')}>
                <Trans
                  i18nKey="space.merchantSpaceLoginPage.supportEmailDescription"
                  ns="pages"
                  components={{
                    externalLink: (
                      <a style={{color: accentColor}} href={`mailto:${merchant.supportEmail}`} />
                    ),
                  }}
                  values={{email: merchant.supportEmail}}
                />
              </p>
            )}
          </div>
        )}
      </CenteredContent>
    </SpacePage>
  );
};

export default MerchantSpaceLoginPage;
